/** Shopify CDN: Minification failed

Line 11:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 16:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 22:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 52:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 95:0 Transforming const to the configured target environment ("es5") is not supported yet

**/
// menu transitions
const megaMenuContents = document.querySelectorAll('.mega-menu__content');

// Loop through each .mega-menu__content element
// megaMenuContents.forEach((megaMenuContent) => {
//   // Create a new IntersectionObserver and set its options
//   const observer = new IntersectionObserver((entries) => {
//     // Loop through the entries array
//     entries.forEach((entry) => {
//       // Check if the entry is intersecting and the mega-menu element is open
//       if (entry.isIntersecting && entry.target.parentNode.hasAttribute('open')) {
//         // Select all elements with the .staggerfade-right class
//         const textElements = entry.target.querySelectorAll('.mega-menu__link');
//         // Loop through the textElements array and animate each element
//         textElements.forEach((textElement, index) => {
//           // Reset the opacity and x properties to their initial values
//           TweenMax.set(textElement, {
//             opacity: 0,
//             x: 20,
//           });
//           // Animate the opacity and x properties
//           TweenMax.to(textElement, 1, {
//             opacity: 1,
//             x: 0,
//             ease: Power4.easeOut,
//             delay: .3 + index * 0.1,
//           });
//         });
//       }
//     });
//   }, {
//     root: null,
//     rootMargin: '0px',
//     threshold: 0.5,
//   });

//   // Observe the current mega-menu__content element
//   observer.observe(megaMenuContent);
// });


// page animations
const staggerfadeElements = document.querySelectorAll('.staggerfade-right, .card');

staggerfadeElements.forEach((element) => {
  element.style.opacity = '0';
  element.style.transform = 'translateX(20px)';
});

// IntersectionObserver to detect when the trigger div is in view
var staggerfadeObserver = new IntersectionObserver(function(entries) {
  entries.forEach(function(entry) {
    if (entry.isIntersecting) {
      // Target the text elements within the trigger div and animate them
      var textElements = entry.target.querySelectorAll('.staggerfade-right, .card');
      textElements.forEach(function(textElement, index) {
        TweenMax.to(textElement, 2, {
          opacity: 1,
          x: 0,
          ease: Power4.easeOut,
          delay: 1 + index * 0.15,
        });
      });
    } else if (entry.target.style.opacity === '1') {
      // Reset the animation properties when the trigger div leaves the viewport
      var textElements = entry.target.querySelectorAll('.staggerfade-right, .card');
      textElements.forEach(function(textElement) {
        TweenMax.set(textElement, {
          opacity: 0,
          x: 30
        });
      });
    }
  });
}, { threshold: [0, 1] });

// Target all trigger divs and observe them with the IntersectionObserver
var staggerfadeTriggerDivs = document.querySelectorAll('.collection, .collection-list-wrapper, .pr-product-item, .page-width, .transition-section, .product-recommendations, .blog');
staggerfadeTriggerDivs.forEach(function(triggerDiv) {
  staggerfadeObserver.observe(triggerDiv);
});



// text with image transitions
const imageElements = document.querySelectorAll('.image-with-text__heading, .samples, .wishlist_icon,  .price, .ingredients_popup,  .installment--wrapper-main, .before-cta-des, .breadcrumb-link-main, h3, .optionSize, .product__accordion, .cstm-meta-bread, .cabinet-bar, .breadcrumbs-dot, .image-with-text__text, .image-with-text__media, dl, dd, dt, .product__text, .product__title, .product__tax, .product__description, .price, variant-radios, .product-form__buttons, .carousel-title, .product-form__input,  .button--secondary, .icon-with-text__item, .share-button, .multicolumn-list__item');

imageElements.forEach((element) => {
  element.style.opacity = '0';
  element.style.transform = 'translateX(20px)';
});

// IntersectionObserver to detect when the trigger div is in view
var imageObserver = new IntersectionObserver(function(entries) {
  entries.forEach(function(entry) {
    if (entry.isIntersecting) {
      // Target the text elements within the trigger div and animate them
      var textElements = entry.target.querySelectorAll('.product__info-wrapper, .image-with-text__heading, .samples, .wishlist_icon,  .price, .ingredients_popup, .installment--wrapper-main, .before-cta-des, .breadcrumb-link-main, h3, .optionSize, .product__accordion, .cstm-meta-bread, .cabinet-bar, .breadcrumbs-dot, .image-with-text__text, .image-with-text__media, dl, dd, dt, .product__text, .product__title, .product__tax, .product__description, .price, variant-radios, .product-form__buttons, .carousel-title, .product-form__input,  .button--secondary, .icon-with-text__item, .share-button, .multicolumn-list__item');
      textElements.forEach(function(textElement, index) {
        TweenMax.to(textElement, 2, {
          opacity: 1,
          x: 0,
          ease: Power4.easeOut,
          delay: .3 + index * 0.15,
        });
      });
    } else if (entry.target.style.opacity === '1') {
      // Reset the animation properties when the trigger div leaves the viewport
      var textElements = entry.target.querySelectorAll('.product__info-wrapper, .image-with-text__heading, .samples, .wishlist_icon,  .price, .ingredients_popup, .installment--wrapper-main, .before-cta-des, .breadcrumb-link-main, h3, h2, .optionSize, .product__accordion, .cstm-meta-bread, .cabinet-bar, .breadcrumbs-dot, .image-with-text__text, .image-with-text__media, dl, dd, dt, .product__text, .product__title, .product__tax, .product__description, .price, variant-radios, .product-form__buttons, .carousel-title, .product-form__input,  .button--secondary, .icon-with-text__item, .share-button, .multicolumn-list__item');
      textElements.forEach(function(textElement) {
        TweenMax.set(textElement, {
          opacity: 0,
          x: 30
        });
      });
    }
  });
}, { threshold: [0, 1] });

// Target all trigger divs and observe them with the IntersectionObserver
var imageTriggerDivs = document.querySelectorAll('.banner, .image-with-text, .collection, .pr-product-item, .page-width, .transition-section, .fifty-container, .accordion, .multicolumn, .product__info-wrapper, .dumy_class_test, .txt_collections, .desktop-scroll, .collapsible-content-wrapper-narrow, .myrich-text, .mini-products-list, .total, .login') ;
imageTriggerDivs.forEach(function(triggerDiv) {
    imageObserver.observe(triggerDiv);
});

